module.exports = __webpack_public_path__ + "ni.svg?fd764d41255c66de30ab88104bf0970e";